if (!customElements.get('hero-carousel')) {
  customElements.define(
    'hero-carousel',
    class HeroCarousel extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('.hero-carousel__track');
        this.slides = Array.from(this.querySelectorAll('.hero-carousel__slide'));
        // Sadece alttaki gezinme noktaları; ürün işaretleri (__pin) buraya girmemeli.
        this.dots = Array.from(this.querySelectorAll('.hero-carousel__dots .hero-carousel__dot'));
        this.arrows = Array.from(this.querySelectorAll('.hero-carousel__arrow'));
        this.currentIndex = 0;
        this.autoplayTimer = null;
      }

      connectedCallback() {
        if (!this.track || this.slides.length === 0) return;

        var requested = Number(this.dataset.startIndex || 1) - 1;
        var startIndex = requested >= 0 && requested < this.slides.length ? requested : 0;
        this.setActive(startIndex);
        if (startIndex > 0) {
          requestAnimationFrame(() => {
            const slide = this.slides[startIndex];
            this.track.scrollLeft = slide.offsetLeft - (this.track.clientWidth - slide.clientWidth) / 2;
          });
        }

        this.arrows.forEach((arrow) => {
          arrow.addEventListener('click', () => {
            const step = arrow.dataset.direction === 'next' ? 1 : -1;
            this.goTo(this.currentIndex + step);
            this.restartAutoplay();
          });
        });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.goTo(Number(dot.dataset.index));
            this.restartAutoplay();
          });
        });

        // Keep the active slide in sync while the visitor swipes/scrolls manually.
        this.track.addEventListener('scroll', () => {
          window.clearTimeout(this.scrollDebounce);
          this.scrollDebounce = window.setTimeout(() => this.syncFromScroll(), 90);
        });

        // Pausing on hover keeps autoplay from yanking the slide away mid-read.
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());

        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      goTo(index) {
        const total = this.slides.length;
        const target = ((index % total) + total) % total;
        const slide = this.slides[target];
        if (!slide) return;

        const offset =
          slide.offsetLeft - (this.track.clientWidth - slide.clientWidth) / 2;
        this.track.scrollTo({ left: offset, behavior: 'smooth' });
        this.setActive(target);
      }

      syncFromScroll() {
        const center = this.track.scrollLeft + this.track.clientWidth / 2;
        let closest = 0;
        let smallestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          const distance = Math.abs(slideCenter - center);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            closest = index;
          }
        });

        this.setActive(closest);
      }

      setActive(index) {
        const changed = this.currentIndex !== index || !this.slides[index].classList.contains('is-active');
        this.currentIndex = index;

        // Yazı animasyonunun her geçişte baştan oynaması için önce is-active'i
        // kaldırıp bir kare bekliyoruz; aksi halde aynı slayta dönüldüğünde
        // tarayıcı geçişi yeniden başlatmaz.
        this.slides.forEach((slide, i) => {
          if (i !== index) slide.classList.remove('is-active');
        });

        const target = this.slides[index];
        if (!target) return;

        if (changed) {
          target.classList.remove('is-active');
          // eslint-disable-next-line no-unused-expressions
          target.offsetWidth; // reflow
        }
        target.classList.add('is-active');

        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      startAutoplay() {
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
        const speed = (Number(this.dataset.autoplaySpeed) || 6) * 1000;
        this.stopAutoplay();
        this.autoplayTimer = window.setInterval(() => this.goTo(this.currentIndex + 1), speed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          window.clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }
  );
}
